import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom"; // Use useNavigate for v6
import { adminLogin } from "../../apis/apisList/adminApi";
import { useApp } from "../../Context/AppContext"; // Import useApp hook
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const AdminLoginForm = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({ username: "", password: "" });
  const navigate = useNavigate(); // Initialize navigate for navigation
  const { login } = useApp();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [searchParams] = useSearchParams();
  const redirectPage = searchParams.get("redirect");

  const validateForm = () => {
    const newErrors = {};
    if (!username) {
      newErrors.username = "Email is required.";
    }
    if (!password) {
      newErrors.password = "Password is required.";
    } else if (password.length < 6) {
      newErrors.password = "Password must be at least 6 characters.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleLogin = async () => {
    if (validateForm()) {
      try {
        setLoading(true);
        const response = await adminLogin({
          email: username,
          password: password,
        });
        setLoading(false);
        // login(response);
        localStorage.removeItem("user");
        localStorage.setItem("jwtToken", response.token);
        localStorage.setItem("admin", JSON.stringify(response.user));
        const url = redirectPage ? redirectPage : "/admindashboard";
        navigate(url);
      } catch (error) {
        setLoading(false);
        console.error("Error during login:", error);
        // Handle network or server error
        const message = error?.response?.data?.message;
        setErrors({
          ...errors,
          username: message || "Something went wrong. Please try again.",
        });
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  const login_style = {
    title: {
      fontSize: "24px",
      fontWeight: "600",
    },
    loginBtn: {
      backgroundColor: "#065F9C",
      boxShadow: "none",
      borderRadius: "10px",
      padding: "12px 20px",
      fontSize: "20px",
      fontWeight: "500",
      textTransform: "inherit",
    },
  };

  return (
    <Box sx={{ width: "100%", maxWidth: "355px" }}>
      <Typography
        style={login_style.title}
        variant="h6"
        align="center"
        sx={{ marginBottom: 4, paddingBottom: 2, borderBottom: 2 }}
      >
        Admin Log in
      </Typography>
      <TextField
        label="Email"
        variant="outlined"
        fullWidth
        value={username}
        onChange={(e) => {
          setUsername(e.target.value);
          setErrors({ ...errors, username: "" }); // Clear the error message
        }}
        error={!!errors.username} // Display error state
        helperText={errors.username} // Display error message
        sx={{
          marginBottom: 3,
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px", // Apply borderRadius here
          },
        }}
      />
      <TextField
        label="Password"
        variant="outlined"
        type={showPassword ? "text" : "password"}
        fullWidth
        value={password}
        onChange={(e) => {
          setPassword(e.target.value);
          setErrors({ ...errors, password: "" }); // Clear the error message
        }}
        error={!!errors.password} // Display error state
        helperText={errors.password} // Display error message
        sx={{
          marginBottom: 3,
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px", // Apply borderRadius here
          },
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
            </InputAdornment>
          ),
        }}
        onKeyUp={handleKeyPress}
      />
      <Button
        style={login_style.loginBtn}
        variant="contained"
        fullWidth
        onClick={handleLogin}
        sx={{
          marginBottom: 0,
          ":disabled": {
            backgroundColor: "gray !important",
            color: "white",
          },
        }}
        disabled={loading} // Disable the button when loading
      >
        {loading ? "Logging in..." : "Log in"}
      </Button>
    </Box>
  );
};

export default AdminLoginForm;
